/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultipleAssetsRequest
 */
export interface MultipleAssetsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof MultipleAssetsRequest
     */
    assets: Array<number>;
}

export function MultipleAssetsRequestFromJSON(json: any): MultipleAssetsRequest {
    return MultipleAssetsRequestFromJSONTyped(json, false);
}

export function MultipleAssetsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipleAssetsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': json['assets'],
    };
}

export function MultipleAssetsRequestToJSON(value?: MultipleAssetsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
    };
}


